module.exports = __webpack_public_path__ + "img/1.e63c8c86.jpg";